var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Close, Search } from '@mui/icons-material';
import { IconButton, InputAdornment, InputBase } from '@mui/material';
import React from 'react';
const InputSearch = (props) => {
    const { value, onChange } = props, rest = __rest(props, ["value", "onChange"]);
    return (React.createElement(InputBase, Object.assign({ type: 'text', value: value, onChange: (e) => onChange(e.target.value), startAdornment: React.createElement(InputAdornment, { position: 'start' },
            React.createElement(Search, { fontSize: 'small' })), endAdornment: React.createElement(InputAdornment, { position: 'end' },
            React.createElement(IconButton, { disableRipple: true, disableTouchRipple: true, onClick: () => onChange('') },
                React.createElement(Close, { fontSize: 'small' }))), sx: (theme) => ({
            width: '100%',
            height: '100%',
            borderRadius: theme.shape.borderRadius,
            padding: '6px 8px',
            bgcolor: 'background.default',
            borderWidth: '0',
            borderStyle: 'solid',
            borderColor: theme.palette.divider,
            input: {
                padding: '0',
                height: '20px',
            },
            '.MuiInputAdornment-positionEnd': Object.assign({ display: 'none', '.MuiButtonBase-root': {
                    padding: theme.spacing(0),
                    margin: theme.spacing(0),
                    svg: {
                        fontSize: '16px',
                    },
                } }, (value.length !== 0 && {
                display: 'flex',
            })),
        }) }, rest)));
};
export default InputSearch;
